import ApiService from 'services/ApiService';

export interface IInspectionPdfService {
  downloadInspectionPdf: (inspectionId: string, inspectionCode: string) => Promise<void>;
}

const InspectionPdfService: IInspectionPdfService = {
  downloadInspectionPdf: async (inspectionId, inspectionCode) => {
    const response = await ApiService.get<Blob>(`/inspections/${inspectionId}/pdf`, { responseType: 'blob' });

    const blob = new Blob([response.data], { type: 'application/pdf' });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `Relatorio-${inspectionCode}.pdf`;

    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  },
};

export default InspectionPdfService;
